import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const purchases = [{
  name: 'Florencia O.',
  location: 'Salta',
  time: 'Hace 2 minutos'
}, {
  name: 'Camila M.',
  location: 'Córdoba',
  time: 'Hace 5 minutos'
}, {
  name: 'Lucía F.',
  location: 'CABA',
  time: 'Hace 12 minutos'
}, {
  name: 'Martina G.',
  location: 'Rosario',
  time: 'Hace 18 minutos'
}, {
  name: 'Sofía R.',
  location: 'Mendoza',
  time: 'Hace 25 minutos'
}];
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Initial delay before first toast
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    let hideTimer: NodeJS.Timeout;
    let showTimer: NodeJS.Timeout;
    if (isVisible) {
      // Hide after 5 seconds
      hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    } else {
      // Show next after 15-25 seconds
      const nextDelay = Math.floor(Math.random() * 10000) + 15000;
      showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        setIsVisible(true);
      }, nextDelay);
    }
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
    };
  }, [isVisible]);
  const currentPurchase = purchases[currentIndex];
  return <AnimatePresence data-id="element-293">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-294">
          <div className="bg-gray-900 border border-gray-700 rounded-xl shadow-2xl p-4 pr-10 relative flex items-start gap-3" data-id="element-295">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-300" data-id="element-296">
              <X size={16} data-id="element-297" />
            </button>

            <div className="bg-green-900/30 p-2 rounded-full shrink-0 mt-0.5" data-id="element-298">
              <CheckCircle2 size={20} className="text-green-500" data-id="element-299" />
            </div>

            <div data-id="element-300">
              <p className="text-xs text-green-400 font-bold mb-1 uppercase tracking-wider" data-id="element-301">
                Compra verificada
              </p>
              <p className="text-sm text-gray-200 leading-tight mb-1" data-id="element-302">
                <span className="font-bold text-white" data-id="element-303">
                  {currentPurchase.name}
                </span>{' '}
                de {currentPurchase.location} compró Megapack Nutricionista 🥗
              </p>
              <p className="text-xs text-gray-500" data-id="element-304">{currentPurchase.time}</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}